import cardimg from "../Assests/images/soundCardimg.jpg";
const musicCardData = [
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
  {
    img: cardimg,
    h5: "True Story bro!...",
    p: "Spotify",
  },
];

export default musicCardData;
